/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { ScheduleDashboardViewModel } from './ScheduleDashboardViewModel'; 

export function getScheduleDashboardOptions(onSuccess?: (result: ScheduleDashboardViewModel) => void) {
	return queryOptions({
		queryKey: ['schedule-dashboard'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/ui/getscheduledashboard/getscheduledashboard/';
			const resp = await axios.get<ScheduleDashboardViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}